import { Component, Input } from '@angular/core';

@Component({
    selector: 'mon-button-next',
    templateUrl: './button-next.component.html',
    styleUrls: ['./button-next.component.scss'],
    standalone: false,
})
class ButtonNextComponent {
    @Input() monType = 'button';
    @Input() monRole = '';
    @Input() monAriaLabel?: string | undefined;
    @Input() monAriaLabeledBy?: string | undefined;
    @Input() monAriaDescribedBy?: string | undefined;
    @Input() monAriaHasPopup?: string | undefined;
    @Input() monAriaControls?: string | undefined;
    @Input() monPressed?: boolean | undefined;
    @Input() monLeftIcon?: string | undefined;
    @Input() monSpinLeftIcon?: boolean | undefined;
    @Input() monRightIcon?: string | undefined;
    @Input() monSpinRightIcon?: boolean | undefined;
    @Input() monCustomButtonImage?: string | undefined;
    @Input() monCustomButtonImageClass?: string | undefined;
    @Input() monDisabled?: boolean | undefined = false;
    @Input() monTooltip?: string | undefined;
}

export { ButtonNextComponent as MonButtonNextComponent };
